import React, { useEffect, useState } from "react";
import useSettings from "../../../../hooks/settings";
import { Settings } from "../../../../models/settings_model";
import { IconButton } from "../../common/buttons";

const Pos: React.FC = () => {
  const [settings, saveSettings] = useSettings();
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    return () => {
      if (updated) {
        window.location.reload();
      }
    };
  }, [updated]);

  const updateSetting = async (ev: { currentTarget: HTMLButtonElement }) => {
    const setting_type = ev.currentTarget.id as keyof Settings;
    const checked = !settings[setting_type];
    await saveSettings(setting_type, checked);
    setUpdated(true);
  };

  return (
    <div className="card">
      <div className="card-body">
        <h3>Punto de Venta</h3>
        <IconButton
          clickFun={updateSetting}
          text="Vista de lista en móvil (sin imágenes)"
          classes="btn-sm"
          checked={settings.pos_list_view ? "true" : undefined}
          id="pos_list_view"
        />
        <small className="form-text text-muted mt-1">
          En teléfonos móviles, muestra los productos del POS como una lista de
          texto en lugar de tarjetas con imagen. Facilita encontrar productos más
          rápido al tomar una orden.
        </small>
      </div>
    </div>
  );
};

export default Pos;
